@let mess = message();
<div class="px-3 inner" [ngClass]="{ unread: !mess.isRead }">
  <div class="notification-item">
    <div class="date">{{ mess.createDate | date: 'medium' }}</div>
    <div class="title">
      @if (subjectTemplate()) {
        <ng-container
          [ngTemplateOutlet]="subjectTemplate()"
          [ngTemplateOutletContext]="{ $implicit: mess }"
        ></ng-container>
      } @else {
        {{ mess.type }}
      }
    </div>
    <div class="flex justify-end w-full gap-2">
      <button mat-button (click)="toggleDetails($event)" class="details-button">
        {{
          (showDetails
            ? 'notification.HIDE_DETAILS'
            : 'notification.SHOW_DETAILS'
          ) | transloco
        }}
      </button>
      @if (!mess.isRead) {
        <button
          mat-button
          (click)="markAsRead($event)"
          class="mark-read-button"
        >
          {{ 'notification.MARK_AS_READ' | transloco }}
        </button>
      }
    </div>
    @if (showDetails) {
      <div class="details">
        @if (bodyTemplate()) {
          <ng-container
            [ngTemplateOutlet]="bodyTemplate()"
            [ngTemplateOutletContext]="{ $implicit: mess }"
          ></ng-container>
        }
      </div>
    }
  </div>
</div>
